import { render } from "./AppSidebar.vue?vue&type=template&id=e8e7ba3c"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\radoslaw\\Documents\\PhpStorm\\sentimentapp_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__